import { render, staticRenderFns } from "./MultiSelectAndInput.vue?vue&type=template&id=235c2a4e&scoped=true&"
import script from "./MultiSelectAndInput.vue?vue&type=script&lang=js&"
export * from "./MultiSelectAndInput.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectAndInput.vue?vue&type=style&index=0&id=235c2a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c2a4e",
  null
  
)

export default component.exports